var map = {
	"./ah.svg": "3ff7",
	"./air-humidity.svg": "0c97",
	"./average-wind-speed.svg": "3ebc",
	"./carbon-dioxide.svg": "9872",
	"./crop.svg": "327d",
	"./dew-point-temp.svg": "5297",
	"./dynamo-db-device.svg": "1b83",
	"./electricity.svg": "6239",
	"./gps-tracker.svg": "21d1",
	"./leaf-moisture-phytos-31.svg": "4709",
	"./leaf-moisture.svg": "6948",
	"./light.svg": "756d",
	"./max-wind-speed.svg": "7cde",
	"./moisture.svg": "75b7",
	"./ph-level.svg": "504e",
	"./phosphine.svg": "d637",
	"./rain-meter.svg": "a10c",
	"./rh.svg": "ee40",
	"./soil-moisture-teros-10.svg": "8ed2",
	"./soil-moisture.svg": "48ee",
	"./solar-radiation.svg": "a5c5",
	"./temperature-humidity.svg": "e95e",
	"./temperature.svg": "9dad",
	"./thermometer.svg": "b2cd",
	"./water.svg": "e122",
	"./weather station-xsense.svg": "e64e",
	"./weather-station.svg": "6ddb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "074b";